import {ConfirmationModalComponent} from '../confirmation/confirmation-modal.component';
import {Contact} from './contact.model';
import {ContactService} from './contact.service';
import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {UIRouter} from '@uirouter/angular';
import {DatatableViewComponent} from '@ngx-ivengi/crud';
import {RoutePrefix} from '../shared/route-prefix';
import {FilterParam} from '@ngx-ivengi/crud/request-params';

@Component({
  selector: 'app-contact-datatable',
  templateUrl: './contact-datatable.component.html'
})
export class ContactDatatableComponent extends DatatableViewComponent<Contact> implements OnDestroy, OnInit {

  @ViewChild(ConfirmationModalComponent)
  public confirmationModal: ConfirmationModalComponent;

  @Output() onContactsLoaded = new EventEmitter<any>();
  @Input() public routePrefix: RoutePrefix | RoutePrefix[];
  @Input() public filterParam: FilterParam | FilterParam[];
  @Input() public linkView: boolean = false;
  @Input() public displayActions: boolean = true;
  public editRoute: string;
  public entityType: string;

  constructor(
    protected contactService: ContactService,
    private router: UIRouter
  ) {
    super(contactService);
  }

  public deleteItem(item) {
    this.confirmationModal.show(item);
  }

  public onDeleteConfirmation(event) {
    if(event.confirmed === true) {
      this.contactService.delete(event.data).subscribe((result) => {
        this.router.stateService.go(this.router.stateService.$current.name, this.router.stateService.params, {reload: true});
      });
    }
  }


  public ngOnDestroy(): void {
    this.contactService.clearRoutePrefix();
  }

  ngOnInit(): void {
    if(this.routePrefix) {
      const prefixParts = (this.routePrefix instanceof Array) ? this.routePrefix : [this.routePrefix];

      const prefix  = prefixParts.map((item) => {

        return `${item.entity}/${item.entityId}`;
      });

      this.contactService.setRoutePrefix(prefix.join('/').toLowerCase());
    }

    if(this.filterParam) {
      this.entityType = (<FilterParam>this.filterParam).value.toUpperCase();
      const filterParam = (this.filterParam instanceof Array) ? this.filterParam : [this.filterParam];
      for(let i = 0; i  < filterParam.length; i++) {
        this.requestParams.addFilterParam(filterParam[i]);
      }
    } else {
      this.entityType = this.router.stateService.$current.name.split('.')[0].toUpperCase();
    }

    this.editRoute = `${this.router.stateService.$current.name}.contact.edit`;

    this.fetchData();
  }

  public fetchData(): void {
    this.loading  = true;
    this.contactService.getAll(this.requestParams).subscribe((data: Contact[]) => {
      this.rows = data;
      this.onContactsLoaded.emit({type: this.entityType, items: this.rows});
      this.loading = false;
    });
  }

  public onRowClick(event) {
    if (event.type !== 'dblclick' || typeof event.column === 'undefined' || event.column.prop === 'menu' || typeof event.row === 'undefined') {
      return;
    }
    this.router.stateService.go('editRoute', { contactId: event.row.id }, { reload: true });
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/contact/contact-datatable.component.ts